import { INavigationContext } from 'framework/context/INavigationContext';
import React from 'react';
import { RfiaDetailTabType } from '../detail/RfiaDetailTabType';

export const NavigationContext = React.createContext<INavigationContext<RfiaDetailTabType>>(undefined as any);
